import { LaravelResponse, keyToUrl } from "@dgs/core";
import axios from "axios";
import { ICampaignUrlResource } from "../../types/campaignUrls";

class CampaignUrlService {
	public keys = {
		bySlug: (slug: string) => ["campaign-url", slug],
	};

	protected urls = {
		bySlug: (slug: string) => keyToUrl(this.keys.bySlug(slug)),
	};

	bySlug(slug: string) {
		return axios.get<LaravelResponse<ICampaignUrlResource>>(this.urls.bySlug(slug));
	}
}

export const campaignUrlService = new CampaignUrlService();
